export const commonUtils = {
    popupDownloadFile: (binary_file, filename = 'download.xlsx') => {
        // 创建一个 Blob 对象
        const blob = new Blob([binary_file]);

        // 创建一个 URL 对象
        const url = window.URL.createObjectURL(blob);

        // 创建一个隐藏的 a 标签来触发下载
        const a = document.createElement("a");
        a.href = url;
        a.download = filename; // 使用动态文件名
        a.click();

        // 清理     
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
}